/** Read-only port of Features/Chat/ReadexSessionModels.swift, ReadOS-iPad.
 * Keep the original WebBundle responsible for bubbles, typography and animation.
 * Native-only actions are supplied separately by the Web host.
 */
export const READEX_MARKDOWN_PROFILE = 'markstream-readex-fade';

export const READEX_PRESENTATION = {
  theme: 'light',
  readexTranscriptTheme: 'codex',
  readexMarkdownRendererProfile: READEX_MARKDOWN_PROFILE,
  readexMarkstreamCodeTheme: null,
  readexMessageFontWeight: 430,
  pageZoom: 1,
  layoutLabVisible: false,
  assistantBubbleSelected: false,
  userBubbleSelected: false,
  usesContainerRelativeMessageLayout: true,
  containerRelativeBubbleBaseWidth: 320,
  containerRelativeGrowthReserveRatio: 0.18,
  containerRelativeMinimumGrowthReserve: 0,
  containerRelativeMaximumGrowthReserve: 0,
  bodyFontSize: 15.5,
  roleFontSize: 12,
  metaFontSize: 11,
  supportFontSize: 14,
  messageGap: 12,
  pagePaddingX: 36,
  pagePaddingY: 18,
  pagePaddingTop: 56.5,
  pagePaddingBottom: 18,
  showsAssistantBubbleBackground: false,
  showsUserBubbleBackground: true,
  assistantBubbleBackgroundColor: 'rgba(0, 0, 0, 0)',
  userBubbleBackgroundColor: 'rgba(0, 0, 0, 0.055)',
  controlBackground: 'rgba(248, 248, 249, 0.98)',
  tooltipBorder: 'rgba(0, 0, 0, 0.08)',
  focusedMessageID: null,
  isConversationGenerating: false,
};
